import { render, staticRenderFns } from "./alterarDiasCorrecao.vue?vue&type=template&id=0bad6e71&"
import script from "./alterarDiasCorrecao.vue?vue&type=script&lang=js&"
export * from "./alterarDiasCorrecao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports